import {PerformanceLogger} from '../performance';
import {LOG_TYPE} from './const';
import {ENVIRONMENT_LEVEL} from '@/Constant';

export class RTEOpLossRatio {
    key = 'RTEOpLossRatio';
    logger: PerformanceLogger | null = null;
    constructor(logger: PerformanceLogger) {
        this.logger = logger;
        window.addEventListener('beforeunload', () => {
            this.logWeb();
        });
    }

    getRatio(changeMode?: boolean) {
        const logger = this.logger;
        const opVersion = logger?.getOpVersionInfo(changeMode);
        return JSON.parse(opVersion || 'null');
    }

    logWeb = () => {
        // 因为是模式变更时会上报
        const originData = this.getRatio(true);
        if (!originData) {
            return;
        }
        const {ack, syn} = originData;
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            logger?.feLogger({
                id: '80001.1.888',
                data: {
                    name: 'opAckRate',
                    sendCount: ack,
                    ackCount: syn,
                },
            });
        }
    };

    getData() {
        const originData = this.getRatio();
        if (!originData) {
            return {};
        }
        const {ack, syn} = originData;
        const lossRatio = (syn - ack) / syn;
        return {
            type: this.key,
            logType: LOG_TYPE.current,
            origin: originData,
            lossRatio,
        };
    }

}
